import * as model from "@/model/prd/productionReport/dayReport/DaySmeltingProductQuality";
import { newEntityStoreHelper } from "@/store/common/entityModule";

import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.DaySmeltingProductQuality(), newFilter)
    .withStates({
        idReport: 2,

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start    
    .withActions({
        getReport(context, entity) {
            router.push("/prd/daySmeltingProductionQuality");
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/daySmeltingProductionQuality/findByDay/" + entity.code
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('daySmeltingProductionQuality' + "/setRows", response.list, { root: true }); 
                    
                    
                }       
            });   
        },
  
      }) 
      .buildStore()